import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Typography } from "antd";
import { ArrowsAltOutlined, CloseOutlined, ShrinkOutlined } from "@ant-design/icons";
const { Title } = Typography;
const DrawerTitle = ({ expand, title, onExpand, onClose }) => {
    return (_jsxs(Flex, { gap: 10, align: "center", children: [_jsxs(Flex, { gap: 5, children: [_jsx(Button, { size: "small", onClick: onClose, type: "text", icon: _jsx(CloseOutlined, {}) }), _jsx(Button, { onClick: onExpand, size: "small", type: "text", icon: expand ? _jsx(ShrinkOutlined, {}) : _jsx(ArrowsAltOutlined, {}) })] }), _jsx(Title, { level: 4, style: { marginBottom: 0 }, ellipsis: { rows: 1, tooltip: title }, children: title })] }));
};
export default DrawerTitle;
